import {
  CloseButton,
  FontWeight,
  Heading,
  LiliButton,
  Text,
  UserMessage,
} from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ForgotPasswordIcon } from '@Assets/icons/forgot-password-profile-error.svg';

type ForgotPasswordModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryAction: () => void;
  isLoading?: boolean;
};

export const ForgotPasswordModal = ({
  isOpen,
  onClose,
  onPrimaryAction,
  isLoading = false,
}: ForgotPasswordModalProps) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <UserMessage id='forgot-password-modal' contentWrapperClassName='cursor-auto' onClick={onClose}>
      <div className='rounded-[12px] bg-surface-primary-bw-01 px-[32px] py-[40px] w-[468px]'>
        <CloseButton
          id='forgot-password-modal-close'
          className='absolute top-[16px] right-[16px]'
          onClick={onClose}
        />
        <div className='flex flex-col items-center'>
          <ForgotPasswordIcon className='w-[88px] h-[88px] mb-[32px]' />
          <Heading.H4 className='text-center mb-[16px]' fontWeight={FontWeight.SEMIBOLD}>
            {t('pages.login.forgotPasswordModal.title')}
          </Heading.H4>
          <Text.H9 className='text-center text-text-main-secondary mb-[42px]'>
            {t('pages.login.forgotPasswordModal.subtitle')}
          </Text.H9>
        </div>
        <LiliButton
          id='forgot-password-modal-button'
          title={t('pages.login.forgotPasswordModal.cta')}
          onClick={onPrimaryAction}
          isLoading={isLoading}
        />
      </div>
    </UserMessage>
  );
};
